export default __webpack_public_path__ + "static/media/vans-K.8663ce38.png";